import Container from "@client/content/Containers/container";
import PieCharts, { type PieChartsProps } from "@client/content/controls/PieCharts/component";
import { getEntityRef, getRootContainerProps } from "@client/content/lib/helper";
import ContentTextStyle from "@client/content/Style/Text";
import { type RootContainerProps } from "@client/content/types";
import * as React from "react";

import "./style.less";

export type PieChartsComponentProps = RootContainerProps & Omit<PieChartsProps, "showPercent"> & {};

export default (props: PieChartsComponentProps) => (
  <Container className="wsc_content_pie_chart" {...getRootContainerProps(props)}>
    <ContentTextStyle {...getEntityRef(props)} textSubSelector=".percent" />

    <div className="pie-chart-container">
      <PieCharts showPercent pieRadius={props.pieRadius} percent={props.percent} options={props.options} />
    </div>
  </Container>
);
